module.exports = __webpack_public_path__ + "static/img/super-chat-pass-off.751dee03.png";